import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject21() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-bottom-left-radius: 0px;\n\tborder-top-left-radius: 0px;\n"]);

  _templateObject21 = function () {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: currentColor;\n\n\t&:hover,\n\t&:focus {\n\t\tcolor: currentColor;\n\t}\n"]);

  _templateObject20 = function () {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n"]);

  _templateObject19 = function () {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: transparent;\n\n\t&:hover,\n\t&:focus {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\n\t&[data-active='true'] {\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject18 = function () {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tborder: 1px solid;\n\tborder-color: ", ";\n\tcolor: ", ";\n\tfont-family: ", ";\n\tfont-size: ", ";\n\n\t&:hover,\n\t&:active,\n\t&:focus {\n\t\tcolor: ", ";\n\t}\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t\tbox-shadow: ", ";\n\t}\n"]);

  _templateObject17 = function () {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n\tcolor: ", ";\n\n\t&:hover,\n\t&:active,\n\t&:focus {\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n"]);

  _templateObject16 = function () {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n\tbottom: 0;\n\tleft: 0;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n"]);

  _templateObject15 = function () {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-left: 0 !important;\n\tposition: relative;\n\tright: ", ";\n"]);

  _templateObject14 = function () {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n\topacity: 1;\n\n\tsvg {\n\t\tdisplay: block;\n\t\tuser-select: none;\n\t}\n"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\twhite-space: nowrap;\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-size: ", ";\n\t/* line-height: 0; */\n\topacity: 1;\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\topacity: 0;\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 100%;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tappearance: none;\n\tbackground-color: transparent;\n\tborder-color: transparent;\n\tborder-radius: ", ";\n\tborder-style: solid;\n\tborder-width: 1px;\n\tbox-shadow: 0 0 0 ", " transparent;\n\tbox-sizing: border-box;\n\tcolor: ", ";\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\tfont-size: ", ";\n\theight: auto;\n\tline-height: 1;\n\tmin-height: ", ";\n\toutline: none;\n\tpadding-bottom: ", ";\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n\tpadding-top: ", ";\n\tposition: relative;\n\ttext-decoration: none;\n\ttouch-action: manipulation; /* Prevents zooming on mobile */\n\tuser-select: none;\n\twidth: auto;\n\n\t&:hover,\n\t&:active,\n\t&:focus {\n\t\ttransition: all ", "\n\t\t\tcubic-bezier(0.12, 0.8, 0.32, 1);\n\t}\n\n\t&[disabled]:not([aria-busy='true']),\n\t&[aria-disabled='true']:not([aria-busy='true']) {\n\t\t", ";\n\t\tcursor: auto;\n\t}\n\n\t&:focus {\n\t\tbox-shadow: ", ";\n\t}\n\n\t&[data-destructive='true'] {\n\t\t&:focus {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n\n\tsvg {\n\t\tdisplay: block;\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Button = css(_templateObject(), ui.get('controlBorderRadius'), ui.get('controlBoxShadowFocusSize'), ui.color.text, ui.get('fontSize'), ui.get('controlHeight'), ui.space(1), ui.get('controlPaddingX'), ui.get('controlPaddingX'), ui.space(1), ui.get('transitionDuration'), ui.opacity.muted, ui.get('controlBoxShadowFocus'), ui.get('controlDestructiveBoxShadowFocus'), ui.get('controlHeight'));
export var destructive = css(_templateObject2(), ui.color.destructive);
export var block = css(_templateObject3());
export var rounded = css(_templateObject4(), ui.borderRadius.circle);
export var large = css(_templateObject5(), ui.get('controlHeightLarge'), ui.get('controlHeightLarge'));
export var small = css(_templateObject6(), ui.padding.y(ui.space(0.5)), ui.padding.x(ui.get('controlPaddingXSmall')), ui.get('controlHeightSmall'), ui.get('controlPaddingXSmall'));
export var xSmall = css(_templateObject7(), ui.padding.y(ui.space(0.5)), ui.padding.x(ui.get('controlPaddingXXSmall')), ui.get('controlHeightXSmall'), ui.get('controlHeightXXSmall'));
export var xxSmall = css(_templateObject8(), ui.padding(0), ui.get('controlHeightXXSmall'), ui.get('controlHeightXXSmall'));
export var icon = css(_templateObject9(), ui.padding.x(0));
export var loading = css(_templateObject10());
export var Content = css(_templateObject11(), ui.get('fontSize'));
export var noWrap = css(_templateObject12());
export var PrefixSuffix = css(_templateObject13());
export var CaretWrapper = css(_templateObject14(), ui.space(-2));
export var LoadingOverlay = css(_templateObject15());
export var subtle = css(_templateObject16(), ui.get('controlBorderColorSubtle'), ui.color.text, ui.get('controlBorderColorSubtle'), ui.color.text, ui.get('buttonPrimaryBorderColorFocus'));
export var control = css(_templateObject17(), ui.get('controlBackgroundColor'), ui.get('controlBorderColor'), ui.color.text, ui.get('fontFamily'), ui.get('fontSize'), ui.color.text, ui.get('buttonPrimaryBorderColorFocus'), ui.get('controlBoxShadowFocus'));
export var subtleControl = css(_templateObject18(), ui.get('controlBackgroundColor'), ui.get('buttonPrimaryBorderColorFocus'), ui.get('controlBackgroundColorActive'), ui.get('colorText'), ui.get('colorTextInverted'));
export var narrow = css(_templateObject19(), ui.get('controlPaddingX'), ui.get('controlPaddingX'));
export var currentColor = css(_templateObject20());
export var split = css(_templateObject21());